import React, { useState } from 'react'
import { Slider } from '@material-ui/core'

type Marks = {
  value: number
  label: string
}

export interface DataSliderProps {
  min: number
  max: number
  step: number
  defaultValues: number | number[],
  marks: Marks[],
  onChange?: (event: React.ChangeEvent<{}>, value: number | number[]) => void;
}

function valuetext (value: number) {
  return `${value}`
}

export default function DataSlider ({ min, max, step, defaultValues, marks, onChange }: DataSliderProps): JSX.Element {
  const [data, setData] = useState(defaultValues)

  const onChangeData = (event: object, value: number | number[]): void => {
    setData(value)
  }
  return (
    <Slider
      getAriaValueText={valuetext}
      aria-labelledby="range-slider"
      valueLabelDisplay="auto"
      min={min}
      max={max}
      step={step}
      marks={marks}
      value={data}
      onChange={onChangeData}
      onChangeCommitted={onChange}
    />
  )
}
